import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useAuth } from '../context/AuthContext';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';

function EventsPage() {
  const { token } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nombre: '', descripcion: '', fechaInicio: '', fechaFin: '' });

  const load = () => {
    api.get(endpoints.events(), token).then(setEvents).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(endpoints.event(editing.id), form, token);
      } else {
        await api.post(endpoints.events(), form, token);
      }
      setModalOpen(false);
      setEditing(null);
      setForm({ nombre: '', descripcion: '', fechaInicio: '', fechaFin: '' });
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleToggleActive = async (ev) => {
    if (!window.confirm(`¿${ev.activo ? 'Desactivar' : 'Activar'} este evento?`)) return;
    try {
      await api.put(endpoints.eventToggle(ev.id), { activo: !ev.activo }, token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const handleDelete = async (ev) => {
    if (!window.confirm('¿Eliminar este evento?')) return;
    try {
      await api.delete(endpoints.event(ev.id), token);
      load();
    } catch (err) {
      alert(err?.message || 'Error');
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'nombre', label: 'Nombre' },
    { key: 'fechaInicio', label: 'Inicio' },
    { key: 'fechaFin', label: 'Fin' },
    {
      key: 'activo',
      label: 'Activo',
      render: (v, row) => (
        <button
          onClick={() => handleToggleActive(row)}
          className={`px-2 py-1 rounded text-xs ${v ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-600'}`}
        >
          {v ? 'Sí' : 'No'}
        </button>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Eventos</h1>
        <button
          onClick={() => {
            setEditing(null);
            setForm({ nombre: '', descripcion: '', fechaInicio: '', fechaFin: '' });
            setModalOpen(true);
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Nuevo evento
        </button>
      </div>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <DataTable
          columns={columns}
          data={events}
          onEdit={(row) => {
            setEditing(row);
            setForm({
              nombre: row.nombre,
              descripcion: row.descripcion || '',
              fechaInicio: row.fechaInicio || '',
              fechaFin: row.fechaFin || '',
            });
            setModalOpen(true);
          }}
          onDelete={handleDelete}
        />
      )}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title={editing ? 'Editar evento' : 'Nuevo evento'}>
        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Nombre</label>
            <input
              value={form.nombre}
              onChange={(e) => setForm((f) => ({ ...f, nombre: e.target.value }))}
              className="w-full px-3 py-2 border rounded"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Descripción</label>
            <textarea
              value={form.descripcion}
              onChange={(e) => setForm((f) => ({ ...f, descripcion: e.target.value }))}
              className="w-full px-3 py-2 border rounded"
              rows={3}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Fecha inicio</label>
              <input
                type="date"
                value={form.fechaInicio}
                onChange={(e) => setForm((f) => ({ ...f, fechaInicio: e.target.value }))}
                className="w-full px-3 py-2 border rounded"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Fecha fin</label>
              <input
                type="date"
                value={form.fechaFin}
                onChange={(e) => setForm((f) => ({ ...f, fechaFin: e.target.value }))}
                className="w-full px-3 py-2 border rounded"
              />
            </div>
          </div>
          <div className="flex gap-2 justify-end">
            <button type="button" onClick={() => setModalOpen(false)} className="px-4 py-2 border rounded">
              Cancelar
            </button>
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Guardar
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default EventsPage;
